
export const useAuth = () => {
    const { clear } = useUserSession()

    const logout = async () => {
        // nuxt-auth-utils' DELETE /api/_auth/session clears the sealed session cookie
        await clear()
        useUserStore().$reset()
        await navigateTo('/login')
    }

    return { logout }
}
